module.exports = "<!-- Main view/routes wrapper-->\r\n<router-outlet></router-outlet>\r\n<paid-feature-upsell-modal></paid-feature-upsell-modal>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/app/app.component.html
// module id = 1270
// module chunks = 0